export const reset = () => {
  localStorage.clear();
  return 'cleared local storage';
};
